import { AxiosError } from 'axios';
import { map, pipe } from './fp';
import { getCrashlytics, recordError as CrashlyticsRecordError } from '@react-native-firebase/crashlytics';
import { isMobileNative } from 'app/utils/constants';
import * as SentryMobile from '@sentry/react-native';
import * as SentryWeb from '@sentry/react';
import { type ErrorInfo } from 'react';

export function log(...args: unknown[]) {
  if (!__DEV__) return;

  const format = <T>(arg: T): T | string => {
    if (arg instanceof AxiosError) {
      return arg.response?.data ? JSON.stringify(arg.response.data, null, 3) : arg.message;
    }

    return typeof arg === 'object' && isMobileNative ? JSON.stringify(arg, null, 3) : arg;
  };

  const formatted = pipe(args, map(format));

  console.log(...formatted);
}

export function recordError(e: unknown, errorInfo?: ErrorInfo) {
  if (__DEV__) {
    if (isMobileNative) {
      console.trace(JSON.stringify(e));
    } else {
      console.error(e);
    }
  }

  if (isMobileNative) {
    const safeError = new Error(e instanceof Error ? e.message : 'Unexpected application error');
    if (e instanceof Error) {
      safeError.name = e.name;
      safeError.stack = e.stack;
    }
    CrashlyticsRecordError(getCrashlytics(), safeError);
    SentryMobile.captureException(safeError);
  } else {
    SentryWeb.captureReactException(e, errorInfo ?? {});
  }
}
